import { ref, onUnmounted } from 'vue'

export const useAudioPlayback = () => {
  const isPlaying = ref(false)
  const playbackTime = ref(0)
  const playbackProgress = ref(0)

  const audioElementRef = ref<HTMLAudioElement | null>(null)

  const load = (blob: Blob) => {
    if (audioElementRef.value) {
      audioElementRef.value.pause()
      audioElementRef.value = null
    }

    const audio = new Audio(URL.createObjectURL(blob))
    audioElementRef.value = audio

    audio.addEventListener('ended', () => {
      isPlaying.value = false
      playbackTime.value = 0
      playbackProgress.value = 0
    })

    audio.addEventListener('timeupdate', () => {
      if (audioElementRef.value) {
        playbackTime.value = Math.floor(audioElementRef.value.currentTime)
        playbackProgress.value = audioElementRef.value.currentTime / audioElementRef.value.duration
      }
    })
  }

  const play = () => {
    if (audioElementRef.value) {
      audioElementRef.value.play()
      isPlaying.value = true
    }
  }

  const pause = () => {
    if (audioElementRef.value) {
      audioElementRef.value.pause()
      isPlaying.value = false
    }
  }

  const toggle = () => {
    if (isPlaying.value) {
      pause()
    } else {
      play()
    }
  }

  const stop = () => {
    if (audioElementRef.value) {
      audioElementRef.value.pause()
      audioElementRef.value.currentTime = 0
      isPlaying.value = false
      playbackTime.value = 0
      playbackProgress.value = 0
    }
  }

  onUnmounted(() => {
    if (audioElementRef.value) {
      audioElementRef.value.pause()
      audioElementRef.value = null
    }
  })

  return {
    isPlaying,
    playbackTime,
    playbackProgress,
    load,
    play,
    pause,
    toggle,
    stop,
  }
}
